/**
 * Save the file in S3 base on the link the server send us
 *
 * @param {string} fileUrl - File url in the mobile
 * @param {string} link - Link to the file in S3
 * @param {number} countFAil - Number of time we tried to save the file and its fail
 *
 * @returns {boolean} If we failed or success to save the file
 */
export async function saveFileInS3(
  file: any,
  link: string,
  countFAil: number = 0
): Promise<boolean> {
  try {
    console.log("saveFileInS3:");
    if (file) {
      if (countFAil === 3) {
        return false;
      } else {
        const fileBlob =
          file instanceof Blob ? file : new Blob([file], { type: "text/csv" });
        // const fileData = await fetch(`file://${fileUrl}`).then((res) => res.blob())
        const response = await fetch(link, {
          method: "PUT",
          headers: {
            "Content-Type": "application/octet-stream", // Set the appropriate content type for your binary data
          },
          body: fileBlob,
        });
        if (response.ok) {
          console.log("File saved successfully!");
          return true;
        } else {
          console.log("Error saving file:", response.statusText);
          return saveFileInS3(file, link, countFAil + 1);
        }
      }
    }
    return true;
  } catch (error) {
    console.error("Error saving file to URL:", error);
    return false;
  }
}
